export default function useProperty<T>() {
  const getProperty = (name: keyof T) => name;

  return getProperty;
}
